import 'bootstrap/dist/js/bootstrap.min';

import 'owl.carousel';

import './components/fotorama';

$(document).ready(function () {
    $('.navbar-toggle').on('click', function (e) {
        e.preventDefault();
        if (!$('body').hasClass('loadingOverlayMenu')) {
            $('body').addClass('showOverlayMenu');
            $('body').addClass('loadingOverlayMenu');
            $('#overlayMenu').show(200, function () {
                $('body').removeClass('loadingOverlayMenu');
            });
        }
    });
    $('.closeOverlayMenu').on('click', function (e) {
        e.preventDefault();
        if (!$('body').hasClass('loadingOverlayMenu')) {
            $('body').removeClass('showOverlayMenu');
            $('body').addClass('loadingOverlayMenu');
            $('#overlayMenu').hide(200, function () {
                $('body').removeClass('loadingOverlayMenu');
            });
        }
    });

    var menuOffsetTop = $('#main-menu-wrapper').offset().top;
    var scrollTop = $('body').scrollTop();

    if (scrollTop === 0) {
        scrollTop = document.scrollingElement.scrollTop;
    }

    $(window).resize(function () {
        menuOffsetTop = $('#main-menu-wrapper').offset().top;
    });

    $(window).scroll(function () {
        scrollTop = $('body').scrollTop();
        if (scrollTop === 0) {
            scrollTop = document.scrollingElement.scrollTop;
        }
        if (scrollTop > menuOffsetTop) {
            $('#main-menu').addClass('fixed');
        } else if (scrollTop <= menuOffsetTop) {
            $('#main-menu').removeClass('fixed');
            $('#main-menu .nav').removeClass('search-open');
            $('#main-menu .search button').removeClass('active');
        }
    });

    $('#main-menu .search button').click(function (e) {
        if (!$(this).hasClass('active')) {
            e.preventDefault();

            $(this).addClass('active');

            var ul = $(this).parents('ul');

            ul.toggleClass('search-open');
        }
    });

    $("#firmy-box-inner").load("https://firmy.lu/ajax/get_companies2.php", function () { });

    if (!$('body').hasClass('single-gallery')) {
        var contentWidth = $('#single-article').width();
    } else {
        var contentWidth = $('#single-gallery').width();
    }

    if($('#praca112-box').length) {
        $("#praca112-box ul").load("https://praca.lublin112.pl/api/_lublin112.php", function () {});
    }

//    $.getJSON("https://www.ogloszenia.lublin112.pl/announcements_l112.php", function (data) {
//        var ogloszeniaContainer = $('#ogloszenia-box ul');
//
//        $.each(data.announcements, function (key, item) {
//            ogloszeniaContainer.append(
//                    '<li id="' + key + '"><div>'
//                    + '<a href="' + item.url + '"><span class="offer-title">'
//                    + item.title
//                    + '</span></a>'
//                    + '<span class="city">' + item.city + '</span> '
//                    + '<span class="price">| ' + item.cost + 'zł</span>'
//                    + '</div>'
//                    + '<a href="' + item.url + '" class="circle"></a>'
//                    + '</li>'
//                    );
//        });
//    });

    if ($('.fotorama')) {
        $('.fotorama').fotorama({width: contentWidth, maxwidth: contentWidth});
    }

    $('.gallery-nav-carousel').owlCarousel({
        loop: false,
        margin: 10,
        nav: true,
        dots: false,
        responsive: {
            0: {
                items: 8
            },
            600: {
                items: 8
            },
            1000: {
                items: 8
            }
        },
        startPosition: $('#_gallery').attr('attr-current-image')
    });

    $('.select-region').click(function (event) {
        event.preventDefault();
        var region_id = $(this).attr('data-region-id');
        var region_name = $(this).attr('data-region-name');

        if (region_id == "false") {
            eraseCookie('your-region-id');
            eraseCookie('your-region-name');
        } else {
            createCookie('your-region-id', region_id, 1);
            createCookie('your-region-name', region_name, 1);
        }

        location.reload();
    });
    
    var config = {
        apiKey: "AIzaSyBWGyU_ZsJproSSX6qjx5X-EvmLfIhhbkI",
        authDomain: "lublin112-dc148.firebaseapp.com",
        projectId: "lublin112-dc148",
        storageBucket: "lublin112-dc148.appspot.com",
        messagingSenderId: "348242428798",
        appId: "1:348242428798:web:3a4d5b3c3a17d4c156292f"
    };
    
    firebase.initializeApp(config);

    const messaging = firebase.messaging();            
            
    messaging.getToken({vapidKey: 'BAum6633cOpVrcctfhaowdswTzYlnuF5oN_I8_UYAzqVnEvkvcFsmgLiUjxEjp7d_wLmWo-yS0rCedMYnIFy40g'}).then((currentToken) => {
        if (currentToken) {
            if (!readCookie('itlu_l112_webpush')) { 
                var request = $.ajax({ 
                    url: options.ajax_url,
                    type: "POST",
                    data: {
                        'action': 'itlu_webpush', 
                        "token": currentToken 
                    },
                    dataType: "json"
                });

                createCookie('itlu_l112_webpush', true, 31);
            }
        } else {                    
            createCookie('itlu_l112_webpush', false, 7);
        }                             
    }).catch((err) => {
        if(Notification.permission === 'denied') {
            createCookie('itlu_l112_webpush', false, 7);
        }
    });      
});

function createCookie(name, value, days) {
    var expires;

    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();
    } else {
        expires = "";
    }
    document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
}

function readCookie(name) {
    var nameEQ = encodeURIComponent(name) + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ')
            c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0)
            return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
}

function eraseCookie(name) {
    createCookie(name, "", -1);
}

